/**
 * escapetoclosemodal
 *
 * allows the user to close a modal with the ESC button
 */

(function() {
	Vue.directive('escapetoclosemodal', {
		bind: function(el, binding, vnode) {
			window.addEventListener(
				'keyup',
				event => {
					if (event.keyCode == 27) {
						// ESC
						vnode.context.closemodals();
					}
				},
				false
			);
		}
	});
})();
